import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

export interface LegendItem {
    name: string;
    amount: number;
    percentage: number;
    color: string;
    icon: string;
    dashArray?: string;
    dashOffset?: number;
}

@Component({
    selector: 'app-dashboard-chart',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatCardModule],
    templateUrl: './dashboard-chart.component.html',
    styleUrls: ['./dashboard-chart.component.css']
})
export class DashboardChartComponent {
    @Input() totalBalance: number = 0;
    @Input() legendItems: any[] = [];

    hoveredItem: any | null = null;

    onSegmentHover(item: any) {
        this.hoveredItem = item;
    }

    onSegmentLeave() {
        this.hoveredItem = null;
    }
}
